import * as apiGetUserPayments from '@/api/userPayments/getUserPayments'
import * as apiGetLatestTransactions from '@/api/userPayments/getLatestTransactions'

export default {
    namespaced: true,
    state: () => ({
        loading: false,
        userPayments: {},
        latestTransactions: [],
        latestTransactionsLoading: false,
    }),
    mutations: {
        gotUserPayments(state, { userId, userPayments }) {
            state.userPayments[userId] = userPayments
            console.log("GOT USER PAYMENTS:", state.userPayments)
        },

        gotLatestTransactions(state, latestTransactions) {
            state.latestTransactions = latestTransactions
            console.log("GOT LATEST TRANSACTIONS:", state.latestTransactions)
        },

        isLoading(state, loading) {
            state.loading = loading
        },

        isLoadingLatestTransactions(state, loading) {
            state.latestTransactionsLoading = loading
        }
    },
    actions: {
        async getUserPayments({ commit }, { userId }) {
            commit('isLoading', true)

            console.log('Getting User Payments');
        
            const result = await apiGetUserPayments.get(userId);
            console.log(result)
            if (result) {
                commit('gotUserPayments', 
                { 
                    userId: userId,
                    userPayments: result 
                })
            }
        
            commit('isLoading', false)
        },

        async getLatestTransactions({ commit }, { limit = 10 }) {
            commit('isLoadingLatestTransactions', true)

            console.log('Getting Latest Transactions', limit);
        
            const result = await apiGetLatestTransactions.get(limit);
            // const result = [];
            console.log(result)
            if (result) {
                commit('gotLatestTransactions', result)
            }
        
            commit('isLoadingLatestTransactions', false)
        },
    },
    getters: {
        userPayments: (state) => (userId) => {
            return state.userPayments[userId]
        },
        
        latestTransactions: (state) => state.latestTransactions,
        latestTransactionsLoading: (state) => state.latestTransactionsLoading,
    }
};